import PropTypes from "prop-types";

import { Box, Typography, Unstable_Grid2 as Grid } from "@mui/material";
import { LogoSquare } from "../../../components/logo";

// TODO: Change subtitle text

export const Layout = (props) => {
  const { children } = props;

  return (
    <Box
      component="main"
      sx={{
        display: "flex",
        flex: "1 1 auto",
      }}
    >
      <Grid container sx={{ flex: "1 1 auto" }}>
        <Grid
          xs={12}
          lg={6}
          sx={{
            backgroundColor: "background.paper",
            display: "flex",
            flexDirection: "column",
            position: "relative",
          }}
        >
          <Box
            component="header"
            sx={{
              left: 0,
              p: 3,
              position: "fixed",
              top: 0,
              width: "100%",
            }}
          >
            <Box
              href="/"
              sx={{
                display: "inline-flex",
                height: 32,
                width: 32,
              }}
            >
              <LogoSquare />
            </Box>
          </Box>
          {children}
        </Grid>
        <Grid
          xs={12}
          lg={6}
          sx={{
            alignItems: "center",

            color: "white",
            display: "flex",
            justifyContent: "center",
            "& img": {
              maxWidth: "100%",
            },
            background:
              "linear-gradient(321.77deg, #E1E0FF 74.96%, #FFFFFF 114.96%)",
          }}
        >
          <Box position="relative">
            <Box
              position="absolute"
              top={0}
              left={0}
              sx={{
                width: "100%",
                height: "100%",
                background:
                  "linear-gradient(245.29deg, #6DC1DC 13.32%, #A690FC 28.55%, #FC96BB 55.55%, #FFC397 84.12%)",
                filter: "blur(182px)",
                transform: "rotate(-15deg)",
                zIndex: 1,
              }}
            >
              Absolute positioned element
            </Box>
            <Box position="inherit" sx={{ zIndex: 1 }}>
              <Typography
                align="center"
                color="inherit"
                sx={{
                  fontSize: "24px",
                  lineHeight: "32px",
                  mb: 1,
                }}
                variant="h1"
              >
                Welcome to{" "}
                <Box
                  component="a"
                  sx={{
                    backgroundColor: "#15B79E",
                    color: "#FFF",
                    paddingX: 2,
                    paddingY: 1,
                    borderRadius: 20,
                    // textTransform: "uppercase",
                  }}
                  target="_blank"
                >
                  Convio
                </Box>
              </Typography>
              {/* <Typography align="center" sx={{ mb: 3 }} variant="subtitle1">
                A professional kit that comes with ready-to-use MUI components.
              </Typography> */}
              <img alt="" src="/assets/login.png" width={500} height={500} />
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

Layout.prototypes = {
  children: PropTypes.node,
};
